<template>
  <div class="company">
    <MobileSidebarWrapper param="subId">
      <template slot="sidebar">
        <Sidebar/>
      </template>
      <template slot="content">
        <router-view/>
      </template>
    </MobileSidebarWrapper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from '@/components/subAccount/sidebar/Sidebar'
import MobileSidebarWrapper from '@/components/common/mobile-sidebar-wrapper/MobileSidebarWrapper'

export default {
  methods: {
    sync() {
      this.$store.dispatch('subAccount/getUsers');

      if (this.$route.params.subId) {
        this.$store.commit('subAccount/setActiveUser', this.$route.params.subId);
      }
    }
  },
  created() {
    this.sync();
  },
  components: {
    Sidebar,
    MobileSidebarWrapper
  }
}
</script>

<style lang="css" scoped>
  .company {
    width: 100%;
    height: 100%;
    display: flex;

  }
</style>
